import {observer} from "mobx-react";
import {useEffect, useRef, useState} from "react";
import {useMobxState} from "../mobx/global-context";
import {Table, Row, Col, Card, Carousel} from "react-bootstrap";
import moment from "moment"
import React from 'react';
import Marquee from "react-easy-marquee";
import {FaArrowUp} from "react-icons/fa";
import QRCode from "react-qr-code";
import Image from 'react-bootstrap/Image'
require('moment/locale/th.js');

const Status = ()=> {
    const state = useMobxState();
    const [bookingResult, setBookingResult] = useState();
    const [allRooms, setAllRoom] = useState([]);
    const [qrData, setQRData] = useState([]);
    const [availableRooms, setAvailableRooms] = useState(null);
    const tmpQRCode = useRef({});
    useEffect(() => {
        state.navBar = false;
        getResults();
        let timer = setInterval(() => {
            getResults();
        }, 7000);
        return () => {
            state.navBar = true;
            clearInterval(timer);
        }
    }, [])

    useEffect(() =>{
        if(bookingResult?.length>0){
            let tmpQRDataState=[];
            bookingResult[0].list.forEach(async b=>{
                if(b.status!='available')return;
                let key = `${b.roomID},${b.dateNow.getTime()}`;
                let tmp = tmpQRCode.current[key];
                if(tmp?.url){
                    tmpQRDataState.push({key,url:tmp.url})
                }else{
                    try{
                        let link = `https://ltic.kku.ac.th/booking/strapi/ltic-auth?qr=${key}`;
                        let urlObject = await getRequest(`/booking/strapi/qrcode?content=${link}`);
                        tmpQRCode.current[key]=urlObject;
                        tmpQRDataState.push({key,url:urlObject.url})
                    }catch(e){
                        console.log(e);
                    }
                }
            })
            // console.log('tmpQRDataState=======',tmpQRDataState);
            setQRData([...tmpQRDataState])
        }
        // let tmpUrl = tmpQRCode.current[key];
        // if(tmpUrl.url){
        //     console.log('===',tmpUrl);
        //     return '';
        // }
        // let link = `https://ltic.kku.ac.th/booking/strapi/ltic-auth?qr=${key}`;
        // console.log('link=',link);
        // try{
        //     let urlObject = await getRequest(`/booking/strapi/qrcode?content=${link}`);
        //     tmpQRCode.current[key]=urlObject;
        //     return '';
        // }catch(e){
        //     console.log('ERROR=',e);
        //     return '';
        // }
    },[bookingResult])

    function getRequest(url) {
        return new Promise((resolve, reject) => {
            fetch(url)
                .then(r => r.json())
                .then(data => {
                    resolve(data);
                }).catch(err => {
                reject(err);
            });
        })
    }

    function getResults() {
        let now = new Date();
        /// set เวลาให้วินาทีเป็น 0 ตลอด ///
        now.setSeconds(0);
        now.setMilliseconds(0);

        /// set เวลาใหม่ขึ้นเอง ///
        // now.setDate(3)
        // now.setMonth(1)
        // now.setHours(9)
        // now.setMinutes(0)
        let dayList = [
            now,
            /*moment().add('1', 'days').toDate(),
            moment().add('2', 'days').toDate()*/
        ];
        fetch('https://ltic.kku.ac.th/booking/strapi/bookings?_limit=-1&startDate_gte=' + moment(now).format('YYYY-MM-DD'))
            .then(res => res.json())
            .then(async data => {
                // console.log('bookings',data);
                let rooms = await getRequest('https://ltic.kku.ac.th/booking/strapi/rooms');
                setAllRoom(rooms);
                // console.log('rooms==', rooms);
                let availableTimeList = [9, 10, 11, 13, 14, 15, 16];
                // let availableTimeList = [9];
                let results = [];
                dayList.forEach(day => {
                    let tNow = moment(day).toDate();
                    tNow.setHours(0, 0, 0);
                    let result = {date: day, list: []};
                    availableTimeList.forEach(t => {
                        tNow.setHours(t, 0, 0);
                        rooms.forEach(room => {
                            let bookingWithRoom = data.filter(b=>b.booking_room.id==room.id);
                            let tNowBookings = bookingWithRoom.filter(booking => {
                                let strStartDate = booking.startDate;
                                let strStartTime = booking.startTime.replace(':00.000', '');
                                let strEndTime = booking.endTime.replace(':00.000', '');
                                let startDateTime = moment(`${strStartDate} ${strStartTime}`).toDate();
                                let endDateTime = moment(`${strStartDate} ${strEndTime}`).toDate();

                                if (
                                    room.id === booking.booking_room.id &&
                                    (
                                        (tNow >= startDateTime && tNow < endDateTime) ||
                                        (moment(tNow).add(59,'minutes').toDate() >= startDateTime && tNow < endDateTime)
                                    )

                                ) {
                                    return true;
                                }
                                return false;
                            });

                            if (tNowBookings.length>0) {
                                console.log('tNowBookings========',tNowBookings);
                                tNowBookings.forEach(existed=>{
                                    let item = {};
                                    item.now = moment(tNow).format('HH:mm');
                                    item.dateNow = moment(tNow).toDate();
                                    item.id = existed.id;
                                    let strStartDate = existed.startDate;
                                    let strStartTime = existed.startTime.replace(':00.000', '');
                                    let strEndTime = existed.endTime.replace(':00.000', '');
                                    let startDateTime = moment(`${strStartDate} ${strStartTime}`).toDate();
                                    let endDateTime = moment(`${strStartDate} ${strEndTime}`).toDate();
                                    item.room = existed.booking_room.name;
                                    let {prefix, firstname, lastname} = existed.booking_user;
                                    item.user = `${prefix}${firstname} ${lastname}`;
                                    item.activity = existed.nameActivity;
                                    item.strStartDate = strStartDate;
                                    item.strStartTime = strStartTime;
                                    item.strEndTime = strEndTime;
                                    if (now >= startDateTime && now <= endDateTime) {
                                        item.status = 'now';
                                    } else if (now >= endDateTime) {
                                        item.status = 'passed';
                                    } else {
                                        item.status = 'coming';
                                    }
                                    result.list.push(item);
                                })
                            } else {
                                let item = {};
                                item.now = moment(tNow).format('HH:mm');
                                item.dateNow = moment(tNow).toDate();
                                item.room = room.name;
                                item.roomID = room.id;
                                if (now >= tNow) {
                                    item.status = 'not available';
                                } else {
                                    item.status = 'available';
                                }
                                result.list.push(item);
                            }
                        });
                    })
                    result.list.sort((a, b) => {
                        if (!a.id) return 1;
                        if (!b.id) return -1;
                        if (a.id < b.id) return -1;
                        if (a.id > b.id) return 1;
                        return 0;
                    });
                    result.list.sort((a, b) => {
                        if (!a.id) return 1;
                        if (!b.id) return -1;
                        if (a.nowDate > b.nowDate) return 1;
                        if (a.nowDate < b.nowDate) return -1;
                        return 0;
                    })
                    results.push(result);
                });
                // console.log('results====', results);
                let available = results?.[0].list.filter(l => l.status == 'available');
                let unique = Array.from(new Set(available.map(a => a.now)));
                let Buffer = {};
                unique.forEach(u => {
                    Buffer[u] = available.filter(l => l.now == u);
                });
                // console.log('availableRooms=', Buffer);
                setAvailableRooms(Buffer)
                // if (qrData.length == 0) setQRData(results);
                setBookingResult(results);
            })
    }

    function getStatusColor(statusText) {
        if (statusText == 'available') {
            return 'status-available'
        } else if (statusText == 'coming') {
            return 'status-coming'
        } else if (statusText == 'now') {
            return 'status-now'
        } else if (statusText == 'passed') {
            return 'status-passed'
        } else if (statusText == 'not available') {
            return 'status-notAvailable'
        }
    }

    async function getQRCodeData(r) {
        // let qr = qrData?.[0]?.list?.find(list => list.now == l.now);
        // if (qr) {
        //     return `https://ltic.kku.ac.th/booking/strapi/ltic-auth?qr=${qr.room.id},${qr.dateNow.getTime()}`;
        // } else {
        //     return `https://ltic.kku.ac.th/booking/strapi/ltic-auth?qr=${l.room.id},${l.dateNow.getTime()}`;
        // }
        // let key = `${r.roomID},${r.dateNow.getTime()}`;
        // let tmpUrl = tmpQRCode.current[key];
        // if(tmpUrl.url){
        //     console.log('===',tmpUrl);
        //     return '';
        // }
        // let link = `https://ltic.kku.ac.th/booking/strapi/ltic-auth?qr=${key}`;
        // console.log('link=',link);
        // try{
        //     let urlObject = await getRequest(`/booking/strapi/qrcode?content=${link}`);
        //     tmpQRCode.current[key]=urlObject;
        //     return '';
        // }catch(e){
        //     console.log('ERROR=',e);
        //     return '';
        // }
    }

    return (
        <>
            <Row noGutters>
                <Col md={9}>
                    <Table className="status-border" variant='dark' style={{backgroundColor: "#303030"}}>
                        <thead>
                        <tr>
                            <td colSpan="5"
                                className="status-date">{moment(bookingResult?.[0]?.date).locale("th").format('วันdddd, DD MMMM YYYY (HH:mm น.)')}</td>
                        </tr>
                        <tr style={{backgroundColor: "#c4c4c4", color:"black"}}>
                            <th className="text-center">Time</th>
                            <th>Room</th>
                            <th>Booking Name</th>
                            <th>Activity</th>
                            <th className="text-center">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {bookingResult?.map(d => {
                            let data = d?.list.filter(l => {
                                if (l.status == 'passed' || l.status == 'not available') return false;
                                return true;
                            });
                            return <React.Fragment key={d.date}>
                                {data.length > 0 ?
                                    <>
                                        {
                                            data.map((l, n) => {
                                                if (l.status == 'available') return;
                                                return <tr key={n}
                                                           style={{backgroundColor: l.status == 'now' ? '#4aa8c5' : ''}}>
                                                    <td className="text-center">{l.now}</td>
                                                    <td>{l.room}</td>
                                                    <td>{l.user}</td>
                                                    <td>{l.activity ? <>({l.strStartTime}-{l.strEndTime})</> : null} {l.activity}</td>
                                                    <td className={getStatusColor(l.status)}>
                                                        <div className="text-capitalize">{l.status}</div>
                                                        {/*{l.status=='available' &&*/}
                                                        {/*     <QRCode size={60} value={getQRCodeData(l)} />*/}
                                                        {/*}*/}
                                                    </td>
                                                    {
                                                        //     l.status=='now'?
                                                        // <td className="text-center" style={{backgroundColor:"black"}}>
                                                        //     <img src="On_air.gif" width="150px"/>
                                                        // </td>
                                                        //     :
                                                        //     <td className={getStatusColor(l.status)}>
                                                        //         <div className="text-capitalize">{l.status}</div>
                                                        //         {l.status=='available' && <img src="qrcode.png"/>}
                                                        //     </td>
                                                    }
                                                </tr>
                                            })
                                        }
                                        {
                                            Object.keys(availableRooms).map(k => {
                                                return <tr>
                                                    <td className="text-center">{k}</td>
                                                    <td colSpan={3}>
                                                        <Row>
                                                            {availableRooms[k].map(r => {
                                                                return <Col xs={3}>
                                                                    <div className="text-center" style={{backgroundColor:'#3f3f3f',borderRadius:8,padding:15,marginBottom:15}}>
                                                                        {r.room}
                                                                        {/*<div><QRCode size={60} value={getQRCodeData(r)} /></div>*/}
                                                                        <div>
                                                                            <Image style={{width:'30%'}} src={qrData.find(qr=>qr.key===`${r.roomID},${r.dateNow.getTime()}`)?.url||''} fluid/>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            })}
                                                        </Row>
                                                    </td>
                                                    <td className="status-available"><div>Available</div></td>
                                                </tr>
                                            })
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            d.list.map((l, n) => {
                                                return <tr key={n}>
                                                    <td className="text-center">{l.now}</td>
                                                    <td>{l.room}</td>
                                                    <td>{l.user ? l.user : "ไม่มีการจอง"}</td>
                                                    <td>{l.activity ? l.activity : "-"}</td>
                                                    <td className="status-passed">
                                                        <div>Finished</div>
                                                    </td>
                                                </tr>
                                            })
                                        }
                                    </>
                                }
                            </React.Fragment>
                        })}
                            </tbody>
                            </Table>
                            </Col>
                            <Col md={3}>
                            <div style={{borderLeft: "1px solid #4c4c4c"}}>
                            <Marquee
                            duration={250000}
                            background="#303030"
                            height={document.body.clientHeight+'px'}
                            width="100%"
                            axis="Y"
                            align="center"
                            pauseOnHover={false}
                            reverse={false}
                            >
                        {allRooms.map(room => {
                            if(room.id == 11 || room.id == 13) return
                            return room.imgs.map(img => {
                            return <>
                            <img key={img.id} src={'/booking/strapi/' + img.url} className="img-fluid"/>
                            <div style={{position:"relative"}}>
                            <span style={{position:'absolute',top:-60,left:-50, backgroundColor:"#303030", color:"white", padding:"5px", opacity:0.8}}>{room.name}</span>
                            </div>
                            </>
                        })
                        })}
                            </Marquee>
                            </div>
                            </Col>
                            </Row>
                            </>
                            )
                        }
export default observer(Status);
